import { WEB_SEARCH_CARD_STATUS_KEY } from '../../tool-card-config';
export const getWebSearchCardData = (tool) => {
    if (!tool.progress || tool.progress.length === 0) {
        return null;
    }
    for (let index = tool.progress.length - 1; index >= 0; index -= 1) {
        const progress = tool.progress[index];
        if (progress.status_key === WEB_SEARCH_CARD_STATUS_KEY &&
            progress.content) {
            try {
                const parsed = JSON.parse(progress.content);
                if (parsed.answer) {
                    return parsed;
                }
            }
            catch (error) {
                console.warn('[WebSearchCard] Failed to parse card data:', error);
            }
        }
    }
    return null;
};
